import { Component, Inject, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { AppMessageService } from 'src/app/services/app-message.service';

@Component({
  selector: 'plan-subgrp-lov',
  templateUrl: './plan-subgrp-lov.component.html',
  styleUrls: ['./plan-subgrp-lov.component.css']
})
export class PlanSubgrpLovComponent implements OnInit {

  planSubgrpModuleId: string = 'BMM114';
  private selectedData: any;
  public titleLov: string = "PLAN SUBGROUP".toUpperCase();

  planSubgrpTable: any = {
    cols: [
      {
        key: "PLAN_SUBGRP",
        header: "Plan Subgroup",
        dataType: "string",
        width: '30%'
      },
      {
        key: "PLAN_SUBGRP_TITLE",
        header: "Plan Subgroup Title",
        dataType: "string"
      },
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  };

  constructor(
    private jsonDataService: JsonDataService,
    private dialogRef: MatDialogRef<PlanSubgrpLovComponent>,
    private _api: APICallService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public fromMainData: any,
  ) {
    this.getPlanSubgrpData();
  }

  ngOnInit(): void {
  }

  onRowClick(ev: any) {
    try {
      this.selectedData = ev;
    } catch (e) {
      console.error(e);  
    }
  }

  private getPlanSubgrpData(): void {
    try {
      this.planSubgrpTable.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getBenefitsCoverage({
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, () => {
            this.securityService.hasValidCsrfToken(data, () => {
              let content = JSON.parse(this.jsonDataService.decrypt(data.response));
              if (content.moduleId === this.planSubgrpModuleId) {
                this.jsonDataService.contorlLoading(false);
                this.planSubgrpTable.tblData = content.data.filter((d: any) => (d.LINE_CD === this.fromMainData.lineCd && d.SUBLINE_CD === this.fromMainData.sublineCd && d.PLAN_CD == this.fromMainData.planCd));
                this.planSubgrpTable.tblData = this.planSubgrpTable.tblData.map((c: any) => { return {...c, PLAN_CD: parseInt(c.PLAN_CD)?.toString().padStart(2, "0")}});
                this.planSubgrpTable.loading = false;
              } else {
                this.planSubgrpTable.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {
            this.securityService.hasValidCsrfToken(e, () => {
              this.planSubgrpTable.loading = false;
              this.jsonDataService.contorlLoading(false);
              this.appMessageService.showAppMessage(e, "error");
            });
          });
        }
      });
    }
    catch (e) {
      console.error(e); 
      this.planSubgrpTable.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }

  onClose(str: string) {
    try {
      if (this.selectedData == '' || this.selectedData == null) {
        this.dialogRef.close({ content: '', button: str });
      }
      else {
        this.dialogRef.close({ content: this.selectedData, button: str });
      }
    } catch (e) {
      console.error(e);
    }
  }

}
